export default {"src":"/_next/static/media/gift.28b51122.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};